<template>
    <div class="price modelArts">
        <slot name="top">
        </slot>
        <loading :size="24"
                 v-if="loading"></loading>
        <Table :columns="columns"
               :data="data"
               v-if="!loading"
               height="270"
               :key="Math.random()">
        </Table>
        <slot name="bottom"
              v-if="!loading">
        </slot>
    </div>
</template>
<script>
import loading from '@c/basic/loading'
export default {
    name: 'modelArtsTable',
    props: ['templateType', 'priceData', 'tabloading'],
    components: {
        loading
    },
    data () {
        return {
            loading: false,
            columns: [],
            data: []
        }
    },
    created () {
        if (this.priceData.length !== 0) {
            this.initData()
        } else {
            this.data = []
            this.loading = false
        }
    },
    watch: {
        priceData (v) {
            if (v && v.length) {
                this.initData()
            } else {
                this.data = []
                this.loading = false
            }
        },
        tabloading (v) {
            this.loading = v
        }
    },
    methods: {
        _handlePricenull (price) {
            return (Number(price) > 0 ? (this.$money(price, 5) + '+') : '')
        },

        initData () {
            // modelArts
            this.loading = true
            const res = this.$deepClone(this.priceData || [])
            if (this.templateType.toLowerCase() === 'modelarts') {
                let billingPrices = res.filter(item => item.productCode === 'ModelArts')
                billingPrices = (billingPrices.length && billingPrices[0].billingPrices) || []
                this.data = billingPrices.filter(item => item.category === 'enterpriseIntelligence')
                this.columns = [
                    {
                        title: this.$t('规格'),
                        key: 'specil',
                        render: (h, params) => {
                            return h('div', { class: 'rc-ellipsis', attrs: { title: `${params.row.productTypeName} (${params.row.productType})` } }, [
                                h('span', `${params.row.productTypeName} (${params.row.productType})`)
                            ])
                        }
                    },
                    {
                        title: this.$t('价格'),
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', this.$t('价格')),
                                h('Tooltip', {
                                    props: { transfer: true, placement: 'right', theme: 'light' }
                                }, [h('i', {
                                    class: {
                                        'icon-prompt-1-o': true,
                                        'tips-style': true
                                    },
                                    style: {
                                        'font-size': '12px',
                                        'padding-right': '5px',
                                        color: '#2d8cf0',
                                        'margin-left': '5px'
                                    }
                                }),
                                h('div', { slot: 'content' }, [
                                    h('p', this.$t('价格计算公式：总价格 = 基础价格 + 单价 * N （N表示用量）'))
                                ])]
                                )
                            ])
                        },
                        key: 'price',
                        // width: 300,
                        // align: 'right',
                        render: (h, params) => {
                            const { unit } = params.row
                            const originalPrice = `(${this._handlePricenull(params.row.fixedHourPrice)} N x${this.$money(params.row.unitHourPrice, 5)}) ` + this.$t(unit)
                            const discountPrice = `(${this._handlePricenull(params.row.tradeFixedHourPrice)} N x${this.$money(params.row.tradeUnitHourPrice, 5)}) ` + this.$t(unit)
                            return h('div', {
                                style: {
                                    padding: '10px 0'
                                }
                            }, [
                                h('p', { class: 'rc-ellipsis', attrs: { title: this.$t('原价：') + originalPrice } },
                                    [
                                        h('span', this.$t('原价：')),
                                        h('span', { attrs: { class: 'balance-color' } }, originalPrice)
                                    ]),
                                h('p', { class: 'rc-ellipsis', attrs: { title: this.$t('折扣价：') + discountPrice } },
                                    [
                                        h('span', this.$t('折扣价：')),
                                        h('span', { attrs: { class: 'balance-color' } }, discountPrice)
                                    ])
                                // h('span', { class: 'rc-ellipsis', attrs: { title: `配置费用: ${this.$money(params.row.unitOncePrice,5)}` } }, `配置费用: ${this.$money(params.row.unitOncePrice,5)}`)
                            ]
                            )
                        }
                    }
                ]
            } else if (this.templateType.toLowerCase() === 'obs') {
                // OBS
                const billingPrices = this.data = res.filter(item => item.productCode === 'OBS') && res.filter(item => item.productCode === 'OBS')[0].billingPrices
                // const res2 = billingPrices.filter(item => item.category === 'blockStorage')
                this.data = billingPrices.filter(item => item.category === 'blockStorage')
                this.columns = [
                    {
                        title: this.$t('名称'),
                        key: 'specil',
                        render: (h, params) => {
                            return h('div', { class: 'rc-ellipsis', attrs: { title: `${params.row.productTypeName} (${params.row.productType})` } }, [
                                h('span', `${params.row.productTypeName} (${params.row.productType})`)
                            ])
                        }
                    },
                    {
                        title: this.$t('价格'),
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', this.$t('价格')),
                                h('Tooltip', {
                                    props: { transfer: true, placement: 'right', theme: 'light' }
                                }, [h('i', {
                                    class: {
                                        'icon-prompt-1-o': true,
                                        'tips-style': true
                                    },
                                    style: {
                                        'font-size': '12px',
                                        'padding-right': '5px',
                                        color: '#2d8cf0',
                                        'margin-left': '5px'
                                    }
                                }),
                                h('div', { slot: 'content' }, [
                                    h('p', this.$t('价格计算公式：总价格 = 基础价格 + 单价 * N （N表示用量）'))
                                ])]
                                )
                            ])
                        },
                        key: 'price',
                        // width: 300,
                        // align: 'right',
                        render: (h, params) => {
                            return h('div', {
                                style: {
                                    padding: '10px 0'
                                }
                            }, [
                                h('p', { class: 'rc-ellipsis', attrs: { title: this.$t('原价：') + `(${this._handlePricenull(params.row.fixedHourPrice)} N x${this.$money(params.row.unitHourPrice, 5)}) /` + this.$t('个/小时') } },
                                    [
                                        h('span', this.$t('原价：')),
                                        h('span', { attrs: { class: 'balance-color' } }, `(${this._handlePricenull(params.row.fixedHourPrice)} N x${this.$money(params.row.unitHourPrice, 5)}) /` + this.$t('个/小时'))
                                    ]),
                                h('p', { class: 'rc-ellipsis', attrs: { title: this.$t('折扣价：') + `(${this._handlePricenull(params.row.tradeFixedHourPrice)} N x${this.$money(params.row.tradeUnitHourPrice, 5)}) /` + this.$t('个/小时') } },
                                    [
                                        h('span', this.$t('折扣价：')),
                                        h('span', { attrs: { class: 'balance-color' } }, `(${this._handlePricenull(params.row.tradeFixedHourPrice)} N x${this.$money(params.row.tradeUnitHourPrice, 5)}) /` + this.$t('个/小时'))
                                    ])
                                // h('span', { class: 'rc-ellipsis', attrs: { title: `配置费用: ${this.$money(params.row.unitOncePrice)}` } }, `配置费用: ${this.$money(params.row.unitOncePrice)}`)
                            ]
                            )
                        }
                    }
                ]
                /*                this.data.push({})
                for (const item of res2) {
                    this.columns.push({
                        // title: item.productTypeName,
                        key: item.productType,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', this.$t(item.productTypeName)),
                                h('Tooltip', {
                                    props: { transfer: true, placement: 'right', theme: 'light' }
                                }, [h('i', {
                                    class: {
                                        'icon-prompt-1-o': true,
                                        'tips-style': true
                                    },
                                    style: {
                                        'font-size': '12px',
                                        'padding-right': '5px',
                                        color: '#2d8cf0',
                                        'margin-left': '5px'
                                    }
                                }),
                                h('div', { slot: 'content' }, [
                                    h('p', this.$t('价格计算公式：总价格 = 基础价格 + 单价 * N （N表示用量）'))])]
                                )
                            ])
                        },
                        // align: 'right',
                        render: (h, params) => {
                            return h('div', {
                                // attrs: { class: 'balance-color' },
                                style: {
                                    // color: '#ff6a01',
                                    padding: '10px 0'
                                }
                            }, [
                                h('p', { class: 'rc-ellipsis', attrs: { title: this.$t('原价：') + `${params.row[item.productType].originalPrice}` } },
                                    [
                                        h('span', this.$t('原价：')),
                                        h('span', { attrs: { class: 'balance-color' } }, params.row[item.productType].originalPrice)
                                    ]),
                                h('p', { class: 'rc-ellipsis', attrs: { title: this.$t('折扣价：') + `${params.row[item.productType].tradePrice}` } },
                                    [
                                        h('span', this.$t('折扣价：')),
                                        h('span', { attrs: { class: 'balance-color' } }, params.row[item.productType].tradePrice)
                                    ])
                                // h('p', { class: 'rc-ellipsis', attrs: { title: `配置费用：${params.row[item.productType].extra}` } },
                                //     [
                                //         h('span', '配置费用：'),
                                //         h('span', { attrs: { class: 'balance-color' } }, params.row[item.productType].extra)
                                //     ])
                                // h('p', { class: 'rc-ellipsis', attrs: { title: params.row[item.productType].originalPrice } }, params.row[item.productType].originalPrice),
                                // h('p', { class: 'rc-ellipsis', attrs: { title: params.row[item.productType].tradePrice } }, params.row[item.productType].tradePrice),
                                // h('p', { class: 'rc-ellipsis', attrs: { title: params.row[item.productType].extra } }, params.row[item.productType].extra)
                            ])
                        }
                    })
                    this.data[0][item.productType] = {
                        originalPrice: `(${this._handlePricenull(item.fixedHourPrice)} N x ${this.$money(item.unitHourPrice)}) /GB` + this.$t('/小时'),
                        tradePrice: `(${this._handlePricenull(item.tradeFixedHourPrice)} N x ${this.$money(item.tradeUnitHourPrice)}) /GB` + this.$t('/小时')
                        // extra: this.$money(item.unitOncePrice)
                    }
                } **/
            } else {
                // situation
                const billingPrices = this.data = res.filter(item => item.productCode === 'situation') && res.filter(item => item.productCode === 'situation')[0].billingPrices
                const res3 = billingPrices.filter(item => item.category === 'blockStorage')
                this.data = []
                this.columns = []
                this.data.push({})
                for (const item of res3) {
                    this.columns.push({
                        // title: item.productTypeName,
                        key: item.productType,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', this.$t(item.productTypeName)),
                                h('Tooltip', {
                                    props: { transfer: true, placement: 'right', theme: 'light' }
                                }, [h('i', {
                                    class: {
                                        'icon-prompt-1-o': true,
                                        'tips-style': true
                                    },
                                    style: {
                                        'font-size': '12px',
                                        'padding-right': '5px',
                                        color: '#2d8cf0',
                                        'margin-left': '5px'
                                    }
                                }),
                                h('div', { slot: 'content' }, [
                                    h('p', this.$t('价格计算公式：总价格 = 基础价格 + 单价 * N （N表示用量）'))])]
                                )
                            ])
                        },
                        // align: 'right',
                        render: (h, params) => {
                            return h('div', {
                                // attrs: { class: 'balance-color' },
                                style: {
                                    // color: '#ff6a01',
                                    padding: '10px 0'
                                }
                            }, [
                                h('p', { class: 'rc-ellipsis', attrs: { title: this.$t('原价：') + `${params.row[item.productType].originalPrice}` } },
                                    [
                                        h('span', this.$t('原价：')),
                                        h('span', { attrs: { class: 'balance-color' } }, params.row[item.productType].originalPrice)
                                    ]),
                                h('p', { class: 'rc-ellipsis', attrs: { title: this.$t('折扣价：') + `${params.row[item.productType].tradePrice}` } },
                                    [
                                        h('span', this.$t('折扣价：')),
                                        h('span', { attrs: { class: 'balance-color' } }, params.row[item.productType].tradePrice)
                                    ])
                                // h('p', { class: 'rc-ellipsis', attrs: { title: `配置费用：${params.row[item.productType].extra}` } },
                                //     [
                                //         h('span', '配置费用：'),
                                //         h('span', { attrs: { class: 'balance-color' } }, params.row[item.productType].extra)
                                //     ])
                                // h('p', { class: 'rc-ellipsis', attrs: { title: params.row[item.productType].originalPrice } }, params.row[item.productType].originalPrice),
                                // h('p', { class: 'rc-ellipsis', attrs: { title: params.row[item.productType].tradePrice } }, params.row[item.productType].tradePrice),
                                // h('p', { class: 'rc-ellipsis', attrs: { title: params.row[item.productType].extra } }, params.row[item.productType].extra)
                            ])
                        }
                    })
                }
            }
            this.loading = false
        }
    }
}
</script>
<style lang="less" >
.price .ivu-table th,
.price .ivu-table td {
    height: 42px;
    // border-bottom: none;
}
.price .ivu-table th {
    background-color: #f0f2f3;
    border-color: #e9e9e9;
}
.price .ivu-table:before {
    height: 0;
}
.price .ivu-table-wrapper {
    margin: 15px 0 !important;
}
.demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(180deg);
    }
    to {
        transform: rotate(360deg);
    }
}
.modelArts {
    .ivu-table th,
    .ivu-table td {
        border-bottom: 1px solid #f5f6f7 !important;
    }
}
</style>
<style lang='less' scoped>
.price {
    .balance-color {
        color: #ff6a01;
    }
}
</style>
